import { render, staticRenderFns } from "./BdcRefreshButton.vue?vue&type=template&id=7e181269"
import script from "./BdcRefreshButton.vue?vue&type=script&lang=js"
export * from "./BdcRefreshButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports